import {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import {ActivityType} from '../../../../../../../backend/interfaces/activity-type';
import {EntityActivitiesRepository} from '../../../../../../../repositories/entity-activities';

export function useFetchActivitiesGroupType(
  activitiesSectorId: string,
  activitiesGroupId: string,
  activityTypeId: string
) {
  const {entityId} = useParams<{entityId: string}>();
  const [data, setData] = useState<ActivityType>();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error>();

  useEffect(() => {
    setIsLoading(true);
    EntityActivitiesRepository.instance
      .getType(entityId, activitiesSectorId, activitiesGroupId, activityTypeId)
      .then((data) => {
        setData(data ?? undefined);

        if (!data) {
          throw Error(`Activity Type not found: ${activityTypeId}.`);
        }
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [activitiesGroupId, activitiesSectorId, activityTypeId, entityId]);

  return {
    data,
    isLoading,
    error,
  };
}
